/**
 * Where the app's routes live, decided at runtime so one build serves both layouts:
 * "/next/" while a tenant's old app still owns "/", and "/" once the tenant is switched
 * to the new app (scripts/deploy/switch-app.sh) or on the demo installation.
 * VITE_APP_BASE overrides it (tests). Vite's `base` (BASE_URL) is separate: it is where the
 * build's assets live, "/platform/<version>/" in production.
 */
export const APP_BASE: string = import.meta.env.VITE_APP_BASE || (/^\/next(\/|$)/.test(window.location.pathname) ? '/next/' : '/')
